import React, { FC, Suspense, useMemo } from 'react';
import { PremiumEssentialsProvider } from '@wix/premium-fed-sdk/@premium-essentials';
import { initI18n, Trans } from '@wix/wix-i18n-config';
import {
  DomainNotConnected as DomainNotConnectedPage,
  DomainNotConnectedModule,
} from '@wix/domain-not-connected-page';

const DomainNotConnected: FC = () => {
  const i18n = useMemo(() => initI18n({ locale: window.__LOCALE__ }), []);

  return (
    <PremiumEssentialsProvider Trans={Trans} i18n={i18n}>
      <Suspense fallback={<></>}>
        <DomainNotConnectedModule.Provider translations={{ Loading: <></> }}>
          <DomainNotConnectedPage />
        </DomainNotConnectedModule.Provider>
      </Suspense>
    </PremiumEssentialsProvider>
  );
};

export default DomainNotConnected;
